import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Container, Illustration, TextContainer } from './NotFound.styled';
import { Button } from 'components/v2/Buttons/Button/Button';
import { Heading } from 'components/v2/Typography/Heading';
import { Text } from 'components/v2/Typography/Text';
import { pageUrl } from 'utilities/pageUrl';

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <div>
        <Illustration src="/notFound.svg" alt="404 Not Found" />
      </div>
      <TextContainer>
        <Heading tag="h1" styledAs="h1" noMargin>
          404 - Page Not Found
        </Heading>
        <Text tag="p" size="lg">
          The page you are looking for doesn't exist or is no longer available.
        </Text>
        <Button
          label={'Go Back'}
          category="primary"
          onClick={() => navigate(pageUrl.dashboard())}
        />
      </TextContainer>
    </Container>
  );
};
